var _rect, _circle, _circle2, _rect2, _path, _path2, _circle3, _circle4, _circle5, _circle6, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenize(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 128,
    height: 128,
    rx: 64,
    fill: "#F8F9FC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 48,
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeDasharray: "6 6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 24,
    fill: "#6741C6",
    fillOpacity: 0.1,
    stroke: "#6741C6",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 28,
    height: 28,
    rx: 4,
    fill: "#6741C6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58 64H70",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64 58V70",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 28,
    r: 8,
    fill: "#6741C6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 64,
    r: 8,
    fill: "#6741C6"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 100,
    r: 8,
    fill: "#6741C6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 64,
    r: 8,
    fill: "#6741C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 40.8L72 56",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2 87.2L72 72",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 87.2L56 72",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8 40.8L56 56",
    stroke: "#6741C6",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenize);
export default __webpack_public_path__ + "static/media/tokenize.c7a6528b60ee33dcf93cab56375d414a.svg";
export { ForwardRef as ReactComponent };